/*!
 * mousemovescroll - v0.0.1 - 2017-12-07
 * github: necmi
 */
function RunMoveScroll(){
    $(document).mousemove(function (position) {
        var ZObject = $("#ZoomImage .modal-dialog");


        var offset = ZObject.offset();
        if (offset != undefined) {
            var top = offset.top;


            if ($(window).width() > 991) {

                var xCord = position.clientX;
                var yCord = position.clientY;
                //console.log(xCord + "--" + yCord);

                var xPercent = (xCord / window.innerWidth) * 47;
                var yPercent = (yCord / window.innerHeight) * 47;
                var wHeight = $(window).height();
                var ModalHeight = $("#ZoomImage .modal-dialog").height();

                var scrollRange = wHeight - top - ModalHeight;

                //console.log(scrollRange);

                $("#ZoomImage").css("margin-top", "-" + (yPercent*2) + "%");
            }
            if ($(window).width() < 991) {

                $("#ZoomImage").css("margin-top", "0%");

            }
        }

    });

    $(window).resize(function () {
        if ($(window).width() < 991) {

            $("#ZoomImage").css("margin-top", "0%");

        }
    });
}

//RunMoveScroll();